package dev.alimmz.portfolio.presentation.theme

import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Typography
import androidx.compose.material3.darkColorScheme
import androidx.compose.material3.lightColorScheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.sp

private val DarkColorScheme = darkColorScheme(
    primary = AndroidGreen,
    onPrimary = Color(0xFF00391E),
    primaryContainer = Color(0xFF0B4F2C),
    onPrimaryContainer = Color(0xFF85F8B5),
    secondary = AndroidGreen,
    onSecondary = Color(0xFF00391E),
    secondaryContainer = PortfolioDarkAccentContainer,
    onSecondaryContainer = Color(0xFFFFDBCA),
    background = PortfolioDarkBackground,
    onBackground = PortfolioDarkTextPrimary,
    surface = PortfolioDarkSurface,
    onSurface = PortfolioDarkTextPrimary,
    surfaceVariant = PortfolioDarkSurfaceVariant,
    onSurfaceVariant = PortfolioDarkTextSecondary,
    outline = PortfolioDarkOutline,
)

private val LightColorScheme = lightColorScheme(
    primary = AndroidGreen,
    onPrimary = DarkGreen,
    primaryContainer = Color(0xFFD5FFE3),
    onPrimaryContainer = DarkGreen,
    secondary = DarkGreen,
    onSecondary = PureWhite,
    secondaryContainer = PortfolioLightAccentContainer,
    onSecondaryContainer = Color(0xFF3E2720),
    background = PortfolioLightBackground,
    onBackground = PortfolioLightTextPrimary,
    surface = PortfolioLightSurface,
    onSurface = PortfolioLightTextPrimary,
    surfaceVariant = PortfolioLightSurfaceVariant,
    onSurfaceVariant = PortfolioLightTextSecondary,
    outline = PortfolioLightOutline,
)

val PortfolioTypography = Typography(
    headlineLarge = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Bold,
        fontSize = 32.sp,
        lineHeight = 40.sp,
        letterSpacing = 0.sp
    ),
    headlineMedium = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Bold,
        fontSize = 28.sp,
        lineHeight = 36.sp,
        letterSpacing = 0.sp
    ),
    titleLarge = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Medium,
        fontSize = 22.sp,
        lineHeight = 28.sp,
        letterSpacing = 0.sp
    ),
    bodyLarge = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Normal,
        fontSize = 16.sp,
        lineHeight = 24.sp,
        letterSpacing = 0.5.sp
    ),
    bodyMedium = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Normal,
        fontSize = 14.sp,
        lineHeight = 20.sp,
        letterSpacing = 0.25.sp
    ),
    labelLarge = TextStyle(
        fontFamily = FontFamily.Default,
        fontWeight = FontWeight.Medium,
        fontSize = 14.sp,
        lineHeight = 20.sp,
        letterSpacing = 0.1.sp
    )
)

@Composable
fun PortfolioTheme(
    darkTheme: Boolean = false,
    content: @Composable () -> Unit
) {
    val colorScheme = if (darkTheme) DarkColorScheme else LightColorScheme

    MaterialTheme(
        colorScheme = colorScheme,
        typography = PortfolioTypography,
        content = content
    )
}
